import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie';
import { useAuth } from '../../../context/AuthContext';
import { AtendimentoForms } from "../../../components/Analise/atendimento-forms";
import { ChatButton } from "../../../components/Analise/chat-button";
import { FilaAtendimento } from "../../../components/Analise/fila-atendimento";
import { Chat } from "../../../components/Analise/chat";
import { useClear } from '../../../hooks/useClear';


export function AnaliseContraProposta() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { validToken, cookies, decodedToken } = useAuth()
  const [, setCookies] = useCookies(['token', 'user'])
  const { clearData } = useClear()
  useEffect(() => {
    validToken(cookies?.token)
    if (!cookies?.user) {
      const decoded = decodedToken()
      setCookies('user', {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
      })
    }
    clearData()
  }, [])
  return (
    <>
      <section>
        <div className="m-4 mt-10 flex max-h-max  flex-grow flex-col overflow-y-auto ">
          <div>
            <button className="aba bg-slate-200">Análise</button>
          </div>
          <div className="mb-2 flex h-[85vh] w-[81%] items-center justify-center gap-2 rounded-lg bg-slate-200 px-2 py-2 border-2">
            <FilaAtendimento />
            <AtendimentoForms />
          </div>

          {!isChatOpen && <ChatButton onClick={() => setIsChatOpen(true)} />}
          <div className="relative">
            <Chat isOpen={isChatOpen} closeSidebar={setIsChatOpen} />
          </div>
        </div>
      </section>
    </>
  );
}
